import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    paginatedArrayContentElementInitialState,
    printInitialState,
    situationInitialState,
    updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  consultationSouscriptionsList: {
    ...paginatedArrayContentElementInitialState,
  },
  bonCommande: {
    ...printInitialState,
  },
  print: { ...printInitialState },
};

/*-------------------------------------------------CONSULTATION-SOUSCRIPTIONS----------------------------------------------------*/
const getConsultationSouscriptionsList = (state) => {
  return updateState("consultationSouscriptionsList", state, {
    ...paginatedArrayContentElementInitialState,
    isLoading: true,
  });
};

const getConsultationSouscriptionsListSuccess = (
  state,
  { content, totalElements }
) => {
  return updateState("consultationSouscriptionsList", state, {
    content,
    totalElements,
    isLoading: false,
    isSuccessed: true,
  });
};

const getConsultationSouscriptionsListFail = (state, payload) => {
  return updateState("consultationSouscriptionsList", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
/*---------------------------------GENERATION-BON-COMMANDE-SOUSCRIPTION----------------------------------*/
const generationBonCommandeSouscription = (state) => {
  return updateState("bonCommande", state, {
    ...printInitialState,
    isLoading: true,
  });
};

const generationBonCommandeSouscriptionSuccess = (
  state,
  { content, type, fileName }
) => {
  return updateState("bonCommande", state, {
    content,
    type,
    fileName,
    isLoading: false,
    isSuccessed: true,
  });
};

const generationBonCommandeSouscriptionFail = (state, payload) => {
  return updateState("bonCommande", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const generationBonCommandeSouscriptionReinitialization = (state) => {
  return updateState("bonCommande", state, {
    ...printInitialState,
  });
};

/*---------------------------------GENERATION-BON-COMMANDE-SOUSCRIPTION----------------------------------*/
const getSituationSouscription = (state) => {
  return updateState("situationSouscription", state, {
    ...situationInitialState,
    isLoading: true,
  });
};

const getSituationSouscriptionSuccess = (
    state,
    { content, totalElements }
) => {
  return updateState("situationSouscription", state, {
    content,
    totalElements,
    isLoading: false,
    isSuccessed: true,
  });
};

const getSituationSouscriptionFail = (state, payload) => {
  return updateState("situationSouscription", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const getSituationSouscriptionReinitialization = (state) => {
  return updateState("situationSouscription", state, {
    ...situationInitialState,
  });
};
/*---------------------------------excel----------------------------------*/
const print = (state) => {
  return updateState("print", state, {
    ...printInitialState,
    isLoading: true,
  });
};

const printSuccess = (state, { content, type, fileName }) => {
  return updateState("print", state, {
    content,
    type,
    fileName,
    isLoading: false,
    isSuccessed: true,
  });
};

const printFail = (state, payload) => {
  return updateState("print", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const printReinitialization = (state) => {
  return updateState("print", state, {
    ...printInitialState,
  });
};
/*************************************************************************** */
const consultationSouscriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------CONSULTATION-SOUSCRIPTIONS----------------------------------------------------*/
    case ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST:
      return getConsultationSouscriptionsList(state, action);
    case ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST_SUCCESS:
      return getConsultationSouscriptionsListSuccess(state, action.payload);
    case ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST_FAIL:
      return getConsultationSouscriptionsListFail(state, action.payload);
    /*-------------------------------------------------GENERATION-BON-COMMANDE-SOUSCRIPTION----------------------------------------------------*/
    case ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION:
      return generationBonCommandeSouscription(state, action.payload);
    case ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_SUCCESS:
      return generationBonCommandeSouscriptionSuccess(state, action.payload);
    case ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_FAIL:
      return generationBonCommandeSouscriptionFail(state);
    case ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_REINITIALIZATION:
      return generationBonCommandeSouscriptionReinitialization(state);
    /*-------------------------------------------------Excel----------------------------------------------------*/
    case ActionsTypes.GENERAL_EXCEL_SOUSCRIPTION_EXPORT:
      return print(state, action.payload);
    case ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_SUCCESS:
      return printSuccess(state, action.payload);
    case ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_FAIL:
      return printFail(state);
    case ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_REINITIALIZATION:
      return printReinitialization(state);
      /*-------------------------------------------------CONSULTATION-SOUSCRIPTIONS----------------------------------------------------*/
    case ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION:
      return getSituationSouscription(state, action);
    case ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION_SUCCESS:
      return getSituationSouscriptionSuccess(state, action.payload);
    case ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION_FAIL:
      return getSituationSouscriptionFail(state, action.payload);

    default:
      return state;
  }
};

export default consultationSouscriptionsReducer;
